import { Row, Col, Button } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DataGrid from 'components/theme_components/DataGrid';
import HeroTitle from 'components/theme_components/HeroTitle';
import DF from 'DisplayFramework';
import { CloseOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import React, { useContext, useEffect, useState } from 'react';
import { FilterConfig, FilterValues } from 'types';
import { useQuery } from 'react-query';
import {
  GetParRateListbyCriteriaParams,
  ParRateResponse,
  ParRateValue,
  getParRateListbyCriteria,
  updateParRateStatus,
} from 'services/parametersService';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ParRateModal from './ParRateModal';
import ModalSFS from 'components/theme_components/ModalSFS';
import IPen from 'icons/IPen';
import ExportXLS from 'components/theme_components/ExportXLS';
import StatCard from 'components/theme_components/StatCard';
import ParRateValueModal from './ParRateValueModal';
import Notifications from 'components/theme_components/Notifications';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';
import ParRateStatusModal from './ParRateStatusModal';
import { toRate } from 'utils/utils';
import { useNavigate } from 'react-router-dom';

export type ParRateListProps = {
  color:string
};

const ParRateList = ({color}:ParRateListProps) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [filterValues, setFilterValues] = useState<FilterValues>({});
  const navigate = useNavigate();
  const [addRateValue, setAddRateValue] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const { isInspect } = useContext(AuthContext);

  const [selectedRateCode, setSelectedRateCode] = useState<any>('');

  const [form] = useForm();

  const [searchs, setsearchs] = useState(false);

  const getSearchParams = () => {
    const formattedStartDate = filterValues.startdate
      ? filterValues.startdate.format('YYYY-MM-DD')
      : '';
    const formattedEndDate = filterValues.enddate
      ? filterValues.enddate.format('YYYY-MM-DD')
      : '';
    return {
      ratecode: filterValues.ratecode || '',
      ratedescription: filterValues.ratedescription || '',
      ratetype: filterValues.ratetype || '',
      ratecategory: filterValues.ratecategory || '',
      ratecodespread:filterValues.ratecodespread
      
    };
  };
  const initialSearchParams: GetParRateListbyCriteriaParams = getSearchParams();

  const [searchParams, setSearchParams] = useState<GetParRateListbyCriteriaParams>(initialSearchParams);

  const {
    data: Rates,
    refetch,
    isFetching,
  } = useQuery(
    ['getParRateListbyCriteria', searchParams],
    () =>
      getParRateListbyCriteria(searchParams).then((res) => res.list || []),
    { refetchOnMount: true }
  );
  // useEffect(() => {
  //   if (Rates) {
  //     Rates?.some((item) => item.parRateLists.length === 0);

  //     // setAddRateValue(true);
  //   }
  // }, [Rates]);
  const filterConfig: FilterConfig[] = [
    {
      key: 'ratecode',
      label: 'ratecode',
      type: 'text',
    },
    {
      key: 'ratedescription',
      label: 'ratedescription',
      type: 'text',
    },
    {
      key: 'SFSRATECAT',
      label: 'ratecategory',
      type: 'select',
    },
  ];

  const columns = [
    {
      dataIndex: 'creationdate',
      key: 'creationdate',
      width: '150px',
    },
    {
      dataIndex: 'ratecode',
      key: 'ratecode',
      width: '100px',
      render: (text: string) => (
        <div style={{ paddingLeft: '12px' }}>{text}</div>
      ),
    },


    {
      dataIndex: 'ratedescription',
      width: '200px',
      key: 'ratedescription',
      render: (text: string) => (
        <div style={{ paddingLeft: '12px' }}>{text}</div>
      ),
    },

    {
      dataIndex: 'ratecategorylabel',
      key: 'ratecategorylabel',
      width: '150px',
    },

    {
      dataIndex: 'ratevalue',
      key: 'ratevalue',
      width: '100px',
      render: (val: number) => (
        <div style={{ paddingLeft: '12px' }}>{toRate(val)}</div>
      ),
    },
    {

      dataIndex: 'ratetype',
      key: 'ratetype',
      width: '100px',
      render: (text: string) => (
        <div style={{ paddingLeft: '12px' }}>
          {text === 'NOMINAL' ? 'Manuel' : 'Automatique'}
        </div>
      ),
    },

    // {
    //   title: '',
    //   key: 'arrow',
    //   width: '80px',
    //   render: (record: ParRateResponse) => (
    //     <ModalSFS
    //       className="color-gray"
    //       trigger={({ setVisible }) => (
    //         <IPen
    //           onClick={() => record.ratetype === 'NOMINAL' && setVisible(true)}
    //           style={{
    //             cursor:
    //               record.ratetype === 'NOMINAL' ? 'pointer' : 'not-allowed',
    //           }}
    //           disabled={record.ratetype === 'NOMINAL' ? false : true}
    //           color={record.ratetype === 'NOMINAL' ? '#4B5672' : '#E5E3E2'}
    //         />
    //       )}
    //       title="updaterate"
    //       footer
    //       width={560}
    //     >
    //       <ParRateValueModal
    //         setVisible={() => false}
    //         data={record.parRateLists as any} // Pass the entire row data directly
    //         refetch={() => {
    //           refetch();
    //         }}
    //       />
    //     </ModalSFS>
    //   ),
    //   onHeaderCell: () => ({
    //     style: { paddingLeft: '12px' },
    //   }),
    // },
     {
          title: '',
          key: 'arrow',
          width: '50px',
          render: (record: ParRateResponse) => <RightOutlined onClick={() => navigate(`/configuration-sfs/rate/${record.ratecode}`)} />,
          onHeaderCell: () => ({
            style: { paddingLeft: '12px' },
          }),
        },
  ];

  const onSelectChange = (
    selectedRowKeys: React.Key[],
    selectedRows: any[]
  ) => {
    setSelectedRows(selectedRows);
    setSelectedRateCode(selectedRows[0].ratecode);
    console.log(selectedRows);
    setIsDisabled(selectedRows.length === 0);
  };
  const handleFilterSearch = (values: any) => {
    console.log('Filter values:', values);
    setSearchParams(values);
  };

  const handleFilterReset = () => {
    setFilterValues({});
    form.resetFields();
  };
  return (
    //<DF.Provider pagcode="parrate">
    <DF.Provider pagcode="productlist">
      <div className="bg-color-gray">
        <HeroTitle
          form={form}
          color={color}
          title="parratelist"
          showFilter
          display
          filterConfig={filterConfig}
          onFilterSearch={handleFilterSearch}
          onFilterReset={handleFilterReset}
          className="productlist"
          noTitleOverlay
        />

        <div className="ut-title-page no-after globalvision">
          {addRateValue && (
            <Row justify="space-between" gutter={16} align="middle">
              <Col span={24}>
                <StatCard
                  title=""
                  value="Veuillez ajouter la valeur du taux."
                  variant="notif"
                  className="mb-8 staticNotf mt-8"
                  valueStyle={{
                    backgroundColor: '#F7C0A929',
                  }}
                  width="100%"
                />
              </Col>
            </Row>
          )}
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: '15px' }}
          >
            <Col className="d-flex justify-start align-center">
              <ModalSFS
                className="color-gray"
                trigger={({ setVisible }) => (
                  <Button
                    disabled={isDisabled}
                    className={
                      !isDisabled
                        ? 'no-border-radius  filter-item ant-btn-outline-primary bg-color-hover'
                        : 'no-border-radius  filter-item '
                    }
                    icon={<CloseOutlined />}
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    <GetLabel label="deletrate" /> ({selectedRows.length})
                  </Button>
                )}
                title="suspensValidation"
                footer
                width={560}
              >
                <ParRateStatusModal
                  data={selectedRows[0]}
                  setVisible={() => false}
                />
              </ModalSFS>
                <Button
                    className="no-border-radius ant-btn-outline-primary ml-2 filter-item ant-btn-add bg-color-hover"
                    onClick={() => navigate(`/configuration-sfs/rate/create`)}
                    icon={<PlusOutlined />}
                  >
                    <GetLabel label="addrate" />
                  </Button>
              {/* <ModalSFS
                className="color-gray"
                trigger={({ setVisible }) => (
                  
                )}
                title="addrate"
                footer
                width={560}
              >
                <ParRateModal
                  setVisible={() => {
                    console.log('eeeeeeeeeeeeeeeeeeee')
                  }}
                  // setAddRateValue={setAddRateValue}
                  onSave={()=>{
                    refetch()
                  }}
                />
              </ModalSFS> */}
            </Col>
            <Col span={5} className="d-flex justify-end align-center">
              <ExportXLS data={Rates || []} filename="Rates" />
            </Col>
          </Row>

          <DataGrid
            columns={columns}
            dataSource={Rates || []}
            rowKey="ratecode"
            hideFilters
            hideTitle
            rowSelection={{
              type: 'checkbox',
              onChange: onSelectChange,
            }}
            pagination={{
              pageSize: 10,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} sur ${total}`,
              showSizeChanger: true,
            }}
            className="no-border-radius"
            isLoading={isFetching}
          />
          <ConfirmModal
            visible={modalVisible}
            status="error"
            message="Voulez-vous suspendre ce taux?"
            onConfirm={() => {
              updateParRateStatus({
                ratecode: selectedRateCode,
                ratestatus: 'TERM',
              }).then((res) => {
                Notifications({
                  status: res.code,
                  message: 'Le taux a été suspendue avec succès',
                  description: res.description,
                  duration: 3,
                  placement: 'top',
                });
                setModalVisible(false);
              });
            }}
            onCancel={() => !isInspect && setModalVisible(false)}
            className="modalConfirmOrCancel"
          />
        </div>
      </div>
    </DF.Provider>
  );
};

export default ParRateList;
